import { api } from './api';
import { Settings } from '../types/api.types';

export const settingsApi = {
    getAllAdmin: (): Promise<Settings[]> =>
        api.get('/admin/settings').then(res => res.data),

    getByKey: (key: string): Promise<Settings> =>
        api.get(`/admin/settings/${key}`).then(res => res.data),

    create: (data: Partial<Settings>): Promise<Settings> =>
        api.post('/admin/settings', data).then(res => res.data),

    update: (key: string, data: Partial<Settings>): Promise<Settings> =>
        api.put(`/admin/settings/${key}`, data).then(res => res.data),

    delete: (key: string): Promise<void> =>
        api.delete(`/admin/settings/${key}`),

    getAllPublic: (): Promise<Settings[]> =>
        api.get('/site/settings').then(res => res.data),

    getByKeyPublic: (key: string): Promise<Settings> =>
        api.get(`/site/settings/${key}`).then(res => res.data),

};